// web's OutlinedInput doesn't forward the ref Select attaches to its input
import {OutlinedInput} from '@mui/material';
import {Alert, Box, Select, Stack, Typography} from '@wellstone-solutions/web';
import {halfWidthSx, toSelectItems, useNoteForm} from '../../../NoteForm';
import {SERVICE_CODES, SERVICE_CODE_DESCRIPTIONS, labelOf} from '../../choices';
import type {ServiceCode} from '../../choices';
import {needsClinicalDocumentation} from '../../rules';
import type {ContactNoteAction, ContactNoteState} from '../../state';
import {TimeFields} from './TimeFields';

const PLACEHOLDER = 'Pick a service code';

export const BillingSection = () => {
  const {state, dispatch} = useNoteForm<ContactNoteState, ContactNoteAction>();
  const code = state.serviceCode;

  return (
    <Stack spacing={3}>
      <TimeFields />
      <Stack spacing={1}>
        <Box sx={halfWidthSx}>
          <Select
            label="Service code"
            items={toSelectItems(SERVICE_CODES)}
            value={code ?? ''}
            canUnselect={false}
            displayEmpty
            renderValue={(value) =>
              value ? (
                labelOf(SERVICE_CODES, value)
              ) : (
                <Box component="span" sx={{color: 'text.disabled'}}>
                  {PLACEHOLDER}
                </Box>
              )
            }
            labelProps={{shrink: true}}
            // Notched so the always-shrunk label doesn't overlap the border while empty
            input={<OutlinedInput notched label="Service code" />}
            containerProps={{required: true, fullWidth: true}}
            onChange={(event) =>
              dispatch({
                type: 'set',
                field: 'serviceCode',
                value: event.target.value as ServiceCode,
              })
            }
          />
        </Box>
        {code && (
          <Typography variant="body2">
            {SERVICE_CODE_DESCRIPTIONS[code]}
          </Typography>
        )}
      </Stack>
      {needsClinicalDocumentation(state) && (
        <Alert severity="warning">
          Email, text or voicemail outreach billed as H0023 needs supporting
          clinical documentation. Describe the clinical purpose of the contact
          in Service provided; administrative check-ins are not billable as
          H0023.
        </Alert>
      )}
    </Stack>
  );
};
